/**
 * Normalizes Supabase `public.shops` rows for maps and staff assignment UI.
 * `location` jsonb: supports { lat, lng }, { latitude, longitude },
 * or GeoJSON Point { type, coordinates: [lng, lat] }.
 */

export function parseShopLocation(location) {
  if (!location || typeof location !== 'object') return null;
  const n = (v) => (typeof v === 'number' && Number.isFinite(v) ? v : null);
  let lat = n(location.lat ?? location.latitude);
  let lng = n(location.lng ?? location.longitude);
  if (lat != null && lng != null) return { lat, lng };
  if (location.type === 'Point' && Array.isArray(location.coordinates)) {
    const [lo, la] = location.coordinates;
    lng = n(lo);
    lat = n(la);
    if (lat != null && lng != null) return { lat, lng };
  }
  return null;
}

/** Map / marker shape used by DashboardShopsMap */
export function normalizeShopRecord(row) {
  if (!row) return null;
  const loc = parseShopLocation(row.location);
  const id = row.id != null ? String(row.id) : '';
  return {
    id,
    name: (row.shop && String(row.shop).trim()) || `Mağaza ${id}`,
    lat: loc?.lat,
    lng: loc?.lng,
    description: row.description != null ? String(row.description) : '',
    mapslink: row.mapslink != null ? String(row.mapslink) : '',
    photos: row.photos,
    created_at: row.created_at,
    _raw: row,
  };
}

export function shopsForMap(rows) {
  return (rows || []).map(normalizeShopRecord).filter((s) => s && Number.isFinite(s.lat) && Number.isFinite(s.lng));
}
